/**
 * Einzel-Run-Polling (Review-Queue Seite 2, Kopf-Fortschritt). Pollt alle 3s,
 * solange der Run aktiv ist, und stoppt auf final — Terminal-Stop-Muster
 * identisch zu `useListingAuditStatus` (`hooks/useListingBuilder.ts:43-52`).
 */

import { useQuery } from '@tanstack/react-query'

import { getRun } from '@/lib/api/channel-content-bulk'

import { isRunActive, textRunKeys } from './runStatus'

export function useContentRun(runId: string | null) {
  return useQuery({
    queryKey: textRunKeys.run(runId ?? ''),
    queryFn: () => getRun(runId!),
    enabled: !!runId,
    refetchInterval: (query) => {
      if (query.state.error) return false
      const run = query.state.data?.run
      return run && isRunActive(run.status) ? 3000 : false
    },
  })
}
